import styled from 'styled-components';
import { Typography, Box } from '@mui/material';
import { Flex, FlexColumn } from '../../../components/Flex';
import { LegendCategory } from '../types';
import { ColorToken } from '../../../style/types';
import { fontSize, getColor, radius, space } from '../../../style/utils';

const Wrapper = styled(FlexColumn)`
  gap: ${space('md')};
`;

const Item = styled(Flex)`
  gap: ${space('sm')};
  align-items: center;
`;

const Name = styled(Typography)`
  color: ${({ theme }) => theme.palette.content.secondary};
  font-size: ${fontSize('md')};
`;

const Dot = styled(Box)<{ $color: ColorToken }>`
  width: 8px;
  height: 8px;
  border-radius: ${radius('round')};
  background: ${({ theme, $color }) => getColor(theme, $color)};
`;

type Props = {
  categories: LegendCategory[];
};

const Legend = ({ categories }: Props) => (
  <Wrapper>
    {categories.map((category) => (
      <Item key={category.name}>
        <Dot $color={category.color} />
        <Name>{category.name}</Name>
      </Item>
    ))}
  </Wrapper>
);

export default Legend;
